import { Component, ErrorInfo, ReactNode } from "react";

type Props = {
    children: ReactNode;
};

type State = {
    hasError: boolean;
};

export default class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("App crashed:", error, errorInfo);
    }

    handleReload = () => {
        this.setState({ hasError: false });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div
                    dir="rtl"
                    className="min-h-dvh w-full flex flex-col items-center justify-center gap-4 bg-darkbg text-white p-6 text-center"
                >
                    <h1 className="text-xl font-bold text-primary">
                        مشکلی پیش اومد!
                    </h1>
                    <p className="text-white/70 text-sm max-w-xs">
                        یه خطای غیرمنتظره رخ داد. لطفاً صفحه رو دوباره بارگذاری کنید.
                    </p>
                    <button
                        onClick={this.handleReload}
                        className="bg-[#f4b400] text-black font-bold px-6 py-3 rounded-xl mt-2"
                    >
                        بارگذاری مجدد
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
